import { ICustomizationOption } from "../types/product.types";
import { ExpandedCardViewProps } from "../types/ui.types";

export const getOptionData = (
  product: ExpandedCardViewProps["product"],
  customizationType: string,
  optionValue: string
): ICustomizationOption | undefined => {
  const customGroup = product.customization?.find(
    (c) => c.type === customizationType
  );
  return customGroup?.options.find((o) => o.value === optionValue);
};